import type { DocMigration } from "../docMigration";

const migration: DocMigration = {
  id: "20260813_removecaseworkdisplayname",
  description: "Remove unused displayName field from casework catalog descriptors",
  apply(json: any) {
    for (const settingsId in json.settings) {
      const settings = json.settings[settingsId];
      if (settings.type !== "CASEWORK_CATALOG_SETTINGS") {
        continue;
      }
      for (const caseworkTypeId in settings.caseworkTypes) {
        delete settings.caseworkTypes[caseworkTypeId].displayName;
      }
    }
    return json;
  },
};

export default migration;
